// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__215Zm","disabled":"FileBtn_disabled__3q3mr","warn":"FileBtn_warn__3hPSM","fade":"FileBtn_fade__1zisq"};